import { useBiSessionContext } from '@components/Contexts/BiSessionContext';
import { useProfileContext } from '@components/Contexts/ProfileContext';
import { useBi } from '@components/Hooks/useBi';
import { copyOfExploreResultsPageGenericClick } from '@wix/bi-logger-marketplace/v2';
import { useCallback } from 'react';

export const useProfilePageBi = () => {
  const logger = useBi();
  const { sessionId } = useBiSessionContext();
  const { entry, origin } = useProfileContext();

  const logTemplateClick = useCallback(
    (templateId?: string, clickType?: string) => {
      logger.report(
        copyOfExploreResultsPageGenericClick({
          clickType,
          sessionId,
          origin,
          entry,
          exploreVersion: 'V2',
          data: JSON.stringify({ templateId }),
        }),
      );
    },
    [logger, sessionId, origin, entry],
  );

  const logProfilePageClick = useCallback(
    (clickType: string, data?: string) => {
      logger.report(
        copyOfExploreResultsPageGenericClick({
          clickType: clickType,
          sessionId,
          origin,
          entry,
          exploreVersion: 'V2',
          data: data ?? '',
        }),
      );
    },
    [logger, sessionId, origin, entry],
  );

  return {
    logTemplateClick,
    logProfilePageClick,
  };
};
